"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _camelCase = _interopRequireDefault(require("../utils/camelCase"));
var _settings = require("../settings");
var updatePricing = function updatePricing(payload) {
  var _getSettings = (0, _settings.getSettings)(),
    priceApi = _getSettings.priceApi;
  if (typeof priceApi === 'string') {
    return (0, _axios["default"])({
      url: priceApi,
      crossDomain: true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload)
    }).then(function (response) {
      return (0, _camelCase["default"])(response);
    });
  }
  if (typeof priceApi === 'function') {
    return priceApi(payload);
  }
  return Promise.resolve();
};
var _default = exports["default"] = updatePricing;
//# sourceMappingURL=pricing.js.map